exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search input{padding:10px;width:400px;border-radius:5px}.search button{padding:10px;width:100px;height:40px;border-radius:5px;background-color:#fa8231;color:#444;font-size:15px;font-weight:700;border:none;cursor:pointer}.input{border-color:#fa8231;border-style:solid}.plot{width:70px;height:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f7850e0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search.vue
// module id = 20
// module chunks = 0